import apiClient from './apiClient';

export const dashboardApi = {
  getStats: async () => {
    const response = await apiClient.get('/dashboard/stats');
    return response.data;
  },
  getHealth: async () => {
    try {
      // Use lightweight liveness endpoint for frequent UI checks
      const response = await apiClient.get('/health/liveness', {
        suppressGlobalErrorToast: true
      });
      return response.data;
    } catch (err) {
      return { status: 'down' };
    }
  },
  getHealthDetailed: async () => {
    try {
      // Use full health endpoint for detailed status checks
      const response = await apiClient.get('/health', {
        suppressGlobalErrorToast: true
      });
      return response.data;
    } catch (err) {
      return { status: 'down' };
    }
  }
};
